export default {
	data() {
		return {
			filterExpressType: { field: "express_type", index: null }
		};
	},
	watch: {
		"filterExpressType.index": {
			handler(newVal) {
				let val = this.filterExpressType;
				if (val.index != null && val.index !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.index });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	}
};
